'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var propTypes = {
  colorScheme: _propTypes2.default.oneOf(['light', 'dark']),

  /**
   * Define button theme
   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
   * for more information
   */
  theme: _propTypes2.default.object
};
var defaultProps = {
  colorScheme: 'dark'
};
/** Prop Receivers */

var base = function base(_ref) {
  var themeFromProvider = _ref.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var _theme$reactackle$com = theme.reactackle.components.tabs.tab,
      fontSize = _theme$reactackle$com.fontSize,
      lineHeight = _theme$reactackle$com.lineHeight,
      textTransform = _theme$reactackle$com.textTransform,
      minHeight = _theme$reactackle$com.minHeight,
      minWidth = _theme$reactackle$com.minWidth,
      maxWidth = _theme$reactackle$com.maxWidth;
  var thickness = theme.reactackle.components.tabs.bar.thickness;
  return '\n    font-size: ' + (0, _reactackleCore.getValueString)(fontSize) + ';\n    line-height: ' + lineHeight + ';\n    text-transform: ' + textTransform + ';\n    min-height: ' + (0, _reactackleCore.getValueString)(minHeight) + ';\n    min-width: ' + (0, _reactackleCore.getValueString)(minWidth) + ';\n    max-width: ' + (0, _reactackleCore.getValueString)(maxWidth) + ';\n    padding-top: ' + (0, _reactackleCore.getValueString)(thickness) + ';\n    padding-bottom: ' + (0, _reactackleCore.getValueString)(thickness) + ';\n  ';
};

var style = function style(_ref2) {
  var themeFromProvider = _ref2.theme,
      colorScheme = _ref2.colorScheme,
      selected = _ref2.selected;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var source = theme.reactackle.components.tabs.tab.style[colorScheme];
  return !selected ? '\n      color: ' + source.fontColor + ';\n      background-color: ' + source.backgroundColor + ';\n      font-weight: ' + source.fontWeight + ';\n      opacity: ' + source.opacity + ';\n      cursor: pointer;\n\n      &:hover {\n        color: ' + source.hover.fontColor + ';\n        background-color: ' + source.hover.backgroundColor + ';\n        font-weight: ' + source.hover.fontWeight + ';\n        opacity: ' + source.hover.opacity + ';\n      }\n\n      &:focus {\n        color: ' + source.focus.fontColor + ';\n        background-color: ' + source.focus.backgroundColor + ';\n        font-weight: ' + source.focus.fontWeight + ';\n        opacity: ' + source.focus.opacity + ';\n      }' : '\n      &,\n      &:hover,\n      &:focus {\n        color: ' + source.selected.fontColor + ';\n        background-color: ' + source.selected.backgroundColor + ';\n        font-weight: ' + source.selected.fontWeight + ';\n        opacity: ' + source.selected.opacity + ';\n        cursor: default;\n      }';
};

var bar = function bar(_ref3) {
  var themeFromProvider = _ref3.theme,
      selected = _ref3.selected,
      colorScheme = _ref3.colorScheme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var thickness = theme.reactackle.components.tabs.bar.thickness,
      backgroundColor = theme.reactackle.components.tabs.bar.style[colorScheme].backgroundColor;
  return selected && '\n      background-color: ' + backgroundColor + ';\n      height: ' + (0, _reactackleCore.getValueString)(thickness) + ';\n  ';
};
/** Styles */


var TabStyled = exports.TabStyled = _styledComponents2.default.div.withConfig({
  displayName: 'TabStyled'
})(['flex-grow:1;display:flex;align-items:stretch;justify-content:center;position:relative;text-align:center;user-select:none;position:relative;', ' ', ' ', ' &::after{display:block;content:\'\';width:100%;position:absolute;bottom:0;left:0;z-index:1;', ';}'], base, style, (0, _reactackleCore.transition)('color, background-color, opacity'), bar);

TabStyled.propTypes = propTypes;
TabStyled.defaultProps = defaultProps;
TabStyled.displayName = 'TabStyled';